import $ from 'jquery';
import 'bootstrap';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.standalone.css';
import 'bootstrap-datepicker';

export default class DatePicker {
  constructor() {
    const $inputs = $('.datepicker');

    if (typeof $.fn.datepicker !== 'function' || $inputs.length === 0) {
      return;
    }

    $inputs
      // Initiating plugin
      .datepicker({
        orientation: 'bottom auto',
        format: 'dd/mm/yyyy',
        autoclose: 'true'
      })
      // Simulating validation
      .on('change', function () {
        const $input = $(this);
        const errorContainerSelector = $input.data('parsley-errors-container');

        if ($input.val()) {
          $input.removeClass('parsley-error');
          $(errorContainerSelector)
            .find('.filled')
            .removeClass('filled')
            .find('.parsley-required')
            .hide();
        } else {
          $input.addClass('parsley-error');
          $(errorContainerSelector)
            .find('.parsley-errors-list')
            .addClass('filled')
            .find('.parsley-required')
            .show();
        }
      });
  }
}



// WEBPACK FOOTER //
// ./vively/scripts/components/form/date-picker.js